import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/shared/services/loading.service';

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.scss', './public.component.en.scss']
})
export class PublicComponent {
  constructor(private router: Router, public loadingService: LoadingService) {
    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationStart) {
    //     this.loadingService.setLoading(true);
    //   } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
    //     this.loadingService.setLoading(false);
    //   }
    // });
  }
}
